import { navbarHeight } from "@nova/constants"
import { useTranslation } from "@nova/use-translation"
import { useResizableSidePanelWidth } from "panels/content/side-panel/SidePanel"
import { useEffect } from "react"
import useMouse from "tools/events/useMouse"

type ToolHoverLabelProps = {
    label: string
}
export const ToolHoverLabel = ({ label }: ToolHoverLabelProps) => {
    const { t } = useTranslation()

    const { mouse, setMouseListener } = useMouse()
    const sidePanelWidth = useResizableSidePanelWidth()

    useEffect(() => {
        setMouseListener(true)
    }, [setMouseListener])

    if (!mouse) return null
    return (
        <div
            style={{
                top: mouse.y + 8 - navbarHeight,
                left: mouse.x + 8 - sidePanelWidth,
            }}
            className="absolute z-[80] text-black text-sm bg-white h-8 rounded-lg py-1 px-2 flex items-center modal-border-gradient"
        >
            {t(label)}
        </div>
    )
}
